import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Cartao } from '../classes/cartao';
import { HttpService } from '../services';

export namespace CartaoBi {

    export class Parser {
        public static fill(origin: any): Cartao {
            return Object.assign(new Cartao(), origin);
        }

        public static fillList(origin: any): Array<Cartao> {
            const items: Array<Cartao> = [];
            for (const item of origin) {
                items.push(Parser.fill(item));
            }
            return items;
        }
    }

    export class Rest {
        constructor(private httpService: HttpService) { }
        public getNumero(): Observable<Response> {
            return this.httpService.pathRest().get('cartao/current/numero/', true);
        }
        public getIndiceConversaoMoeda(): Observable<Response> {
            return this.httpService.pathRest().get('cartao/current/indice/', true);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/resources/bi/cartao.bi.ts